import React from 'react';
import { RIPPLE_DOT, RIPPLE_PATHS } from '../utils/rippleMark';
type LenticMarkProps = {
  /** Rendered square size in px. */
  size?: number;
  className?: string;
  /** Accessible label. Pass null for decorative use. */
  title?: string | null;
};

/**
 * The ripple mark on its own, drawn as vector so it stays crisp at any scale
 * and carries no background plate. Used for the oversized watermarks.
 */
export function LenticMark({
  size = 48,
  className,
  title = 'Lentic'
}: LenticMarkProps) {
  return <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} role={title ? 'img' : 'presentation'} aria-label={title ?? undefined} aria-hidden={title ? undefined : true} data-id="element-20" data-mp="1iu4yvedwfnom">
      {RIPPLE_PATHS.map(d => <path key={d} d={d} stroke="#12564f" strokeWidth="3.2" strokeLinecap="round" data-id="element-21" data-mp="14v5a86qdz8sg" />)}
      <circle cx={RIPPLE_DOT.cx} cy={RIPPLE_DOT.cy} r={RIPPLE_DOT.r} fill="#12564f" data-id="element-22" data-mp="zwc634wzou4y" />
    </svg>;
}